import React from "react";
import { Helmet } from "react-helmet";
import ContactUsSection from "../components/ContactUsSection";

function Contact() {
  return (
    <div>
      <Helmet>
        <title>찾아오시는 길 - 채움기획</title>
        <meta name="description" content="채움기획의 위치와 연락처를 확인하세요." />
        <meta name="keywords" content="찾아오시는 길, 채움기획, contact" />
        <link rel="canonical" href="https://cheumad.kr/contact"/>
        <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "BreadcrumbList",
              "@id": "https://cheumad.kr/contact/#breadcrumblist",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "@id": "https://cheumad.kr/#listItem",
                  "position": 1,
                  "name": "홈",
                  "item": "https://cheumad.kr/",
                  "nextItem": "https://cheumad.kr/contact/#listItem"
                },
                {
                  "@type": "ListItem",
                  "@id": "https://cheumad.kr/contact/#listItem",
                  "position": 2,
                  "name": "찾아오시는 길",
                  "previousItem": "https://cheumad.kr/#listItem"
                }
              ]
            },
            {
              "@type": "Organization",
              "@id": "https://cheumad.kr/#organization",
              "name": "채움기획",
              "url": "https://cheumad.kr/",
              "logo": "https://cheumad.kr/logo.png",
              "contactPoint": [
                {
                  "@type": "ContactPoint",
                  "Owner": "홍성준",
                  "E-mail": "fate_ad@naver.com",
                }
              ]
            },
            {
              "@type": "WebPage",
              "@id": "https://cheumad.kr/contact/#webpage",
              "url": "https://cheumad.kr/contact/",
              "name": "찾아오시는 길 - 채움기획",
              "inLanguage": "ko-KR",
              "isPartOf": {
                "@id": "https://cheumad.kr/#website"
              },
              "breadcrumb": {
                "@id": "https://cheumad.kr/contact/#breadcrumblist"
              },
              "datePublished": "2025-01-01T00:00:00+09:00",
              "dateModified": "2025-01-01T00:00:00+09:00"
            },
            {
              "@type": "WebSite",
              "@id": "https://cheumad.kr/#website",
              "url": "https://cheumad.kr/",
              "name": "채움기획",
              "inLanguage": "ko-KR",
              "publisher": {
                "@id": "https://cheumad.kr/#organization"
              }
            },
            {
              "@type": "SiteNavigationElement",
              "@id": "https://cheumad.kr/#siteNavigation",
              "name": ["포트폴리오", "문의하기"],
              "url": ["https://cheumad.kr/portfolio", "https://cheumad.kr/contact"]
            }
          ]
        })}
        </script>
      </Helmet>
      <ContactUsSection />
    </div>
  );
}

export default Contact;